module.exports = __webpack_public_path__ + "assets/img/purple-tick.70938b28.svg";